import React from "react";
import { CheckIcon } from "@radix-ui/react-icons";
import * as C from "@radix-ui/react-checkbox";
import clsx from "clsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Checkbox = props => {
  var {
    children,
    id,
    checked = false,
    error,
    onChange,
    className = "",
    boxClassName = ""
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      id: id,
      className: clsx("flex gap-4", className),
      children: [/*#__PURE__*/_jsx(C.Root, {
        className: clsx("bg-white px-3 py-1.5 h-6 w-6 border border-grey-300/20 rounded-container flex items-center justify-center", boxClassName),
        checked: checked,
        onCheckedChange: onChange,
        children: /*#__PURE__*/_jsx(C.Indicator, {
          children: /*#__PURE__*/_jsx(CheckIcon, {})
        })
      }), /*#__PURE__*/_jsx("label", {
        htmlFor: id,
        className: "cursor-pointer select-none",
        onClick: () => onChange && onChange(!checked),
        children: children
      })]
    }), error && /*#__PURE__*/_jsx("small", {
      className: "text-red-400 p-1",
      children: error
    })]
  });
};
//# sourceMappingURL=checkbox.js.map